import React, { useEffect } from "react";
import { useHistory, useQueryParamString } from "polyrouter";
import {
  useResendVerifyEmailMutation,
  useEmailVerifiedQuery
} from "generated/graphql";
import { DISMISS, useNotification } from "collections/Notifications";
import { DefaultModalForm } from "collections/Modal";
import { CancelButton, LoadingIndicator, SubmitButton } from "elements";
import { useAuth0 } from "@auth0/auth0-react";
import { useTranslation } from "utilities/i18n";
import { useDesktopUserOnly } from "rbac";
import "./Verify.scss";
import { isNew } from "../../Constants";

export const Verify: React.FC = () => {
  const { push } = useHistory();
  const [addNotification] = useNotification();
  const { t } = useTranslation();
  const { logout, user, isAuthenticated } = useAuth0();
  const [success] = useQueryParamString<string>("success");
  const user_email_verified = user?.email_verified;
  const unverified =
    user && isAuthenticated && !user[isNew] && !user.email_verified;
  const isDesktopUser = useDesktopUserOnly();
  const { data, fetching: verifyFetching } = useEmailVerifiedQuery();
  const email_verified = data?.user.user?.email_verified;
  let title = "";
  let body = "";
  let sent = false;

  const [
    { data: resendData, fetching },
    resendEmail
  ] = useResendVerifyEmailMutation();

  const handleResendEmail = () => {
    resendEmail({
      id: user?.sub || ""
    });
  };
  if (resendData?.resendVerifyEmail) {
    sent = true;
  }

  useEffect(() => {
    if (success || user_email_verified || email_verified) {
      if (isDesktopUser) {
        push("/download");
      } else {
        push("/home");
        addNotification({
          type: "success",
          message: t("VERIFIED_EMAIL"),
          dismiss: DISMISS.DEFAULT
        });
      }
    }
    // omit t and addNotification from deps, otherwise causes useEffect to call infinitely with no usefulness
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success, user_email_verified, isDesktopUser, email_verified, push]);

  if (verifyFetching) {
    return <LoadingIndicator />;
  }

  if (!success || unverified) {
    // unverified users OR verification failed

    if (!success) {
      title = t("TRY_AGAIN_TITLE");
      body = t("VERIFY_ERROR");
    }
    if (unverified) {
      title = t("VERIFY_TITLE");
      body = t("VERIFY_INSTRUCTIONS");
    }

    return (
      <DefaultModalForm
        title={title}
        onSubmit={() => handleResendEmail()}
        name="VerifyEmail"
      >
        {({ isSubmitting }) => (
          <div>
            <div className="body-content">{body}</div>
            <div className="btn-container">
              <CancelButton
                onClick={() =>
                  logout({
                    federated: true,
                    returnTo: window.location.origin
                  })
                }
              />
              <SubmitButton
                isSubmitting={isSubmitting}
                disabled={fetching}
                labelKey={sent ? "VERIFY_SENT" : "RESEND"}
                submittingLabelKey="SENDING"
              />
            </div>
          </div>
        )}
      </DefaultModalForm>
    );
  }

  if (isDesktopUser) {
    push("/download");
    return <></>;
  }

  push("/home");
  return <></>;
};

export default Verify;
